/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LicenseRead
 */
export interface LicenseRead {
    /**
     * 
     * @type {string}
     * @memberof LicenseRead
     */
    license_key: string;
    /**
     * 
     * @type {string}
     * @memberof LicenseRead
     */
    license_type: string;
    /**
     * 
     * @type {number}
     * @memberof LicenseRead
     */
    max_users: number;
    /**
     * 
     * @type {boolean}
     * @memberof LicenseRead
     */
    is_active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof LicenseRead
     */
    valid_until?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof LicenseRead
     */
    notes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LicenseRead
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof LicenseRead
     */
    created_at: Date;
    /**
     * 
     * @type {string}
     * @memberof LicenseRead
     */
    organization_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LicenseRead
     */
    organization_name?: string | null;
}

/**
 * Check if a given object implements the LicenseRead interface.
 */
export function instanceOfLicenseRead(value: object): value is LicenseRead {
    if (!('license_key' in value) || value['license_key'] === undefined) return false;
    if (!('license_type' in value) || value['license_type'] === undefined) return false;
    if (!('max_users' in value) || value['max_users'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function LicenseReadFromJSON(json: any): LicenseRead {
    return LicenseReadFromJSONTyped(json, false);
}

export function LicenseReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicenseRead {
    if (json == null) {
        return json;
    }
    return {
        
        'license_key': json['license_key'],
        'license_type': json['license_type'],
        'max_users': json['max_users'],
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
        'valid_until': json['valid_until'] == null ? undefined : (new Date(json['valid_until'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'id': json['id'],
        'created_at': (new Date(json['created_at'])),
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
    };
}

export function LicenseReadToJSON(json: any): LicenseRead {
    return LicenseReadToJSONTyped(json, false);
}

export function LicenseReadToJSONTyped(value?: LicenseRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'license_key': value['license_key'],
        'license_type': value['license_type'],
        'max_users': value['max_users'],
        'is_active': value['is_active'],
        'valid_until': value['valid_until'] == null ? undefined : ((value['valid_until'] as any).toISOString()),
        'notes': value['notes'],
        'id': value['id'],
        'created_at': ((value['created_at']).toISOString()),
        'organization_id': value['organization_id'],
        'organization_name': value['organization_name'],
    };
}

